import useVenues from './useVenues';

export default useVenues;
